import { Body, MaterialIcon, Stack } from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';

const NoSteps = () => {
  const t = useTranslate();
  return (
    <Stack
      data-testid="update-application-nosteps"
      spacing="xxl"
      align="center"
      justify="center"
      p="1.5em"
    >
      <MaterialIcon src="checklist" filled size="48" color="Icon/Default" />
      <Body size="lg" data-record>
        {t('UpdateApplication.NoSteps')}
      </Body>
    </Stack>
  );
};

export default NoSteps;
